import "./anexoII3.scss";
import { Formik, Form } from "formik";
import { useEffect, useState } from "react";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";
import Header from "../../components/molecules/header/Header";
import {
  getListadoRequisitosFormacion,
  getListadoTitulacionesAcademicas,
  insertRequisitosAnexoII3,
} from "../../components/services/ConcursosService";
import Footer from "../../components/molecules/footer/Footer";
import { useLocation, useParams } from "react-router-dom";
import { SpinnerCircleMini } from "../../components/atoms/spinner/Spinner";
import { Iconos } from "../../utils/Iconos";

const AnexoII3 = () => {
  const location = useLocation();
  
  
  const [titulacionesSelect, setTitulacionesSelect] = useState([]);
  const [requisitosSelect, setRequisitosSelect] = useState([]);
  const [requisitosMostar, setRequisitosMostrar] = useState(true);
  const [titulacionesMostar, setTitulacionesMostrar] = useState(true);

  const params = useParams() || {};

  const createRequisito = () => ({
    organismo: "",
    requisito1: "",
    requisito2: "",
  });

  const [show, setShow] = useState({
    mensaje: false,
  });

  const handleClose = (e) => {
    setShow(false);
  };

  const [titulaciones, setTitulaciones] = useState([
    {
      titulo: "",
      organismo: "",
    },
  ]);
  const [requisitos, setRequisitos] = useState([
    {
      organismo: "",
      requisito1: "",
      requisito2: "",
    },
  ]);

  const anadirTitulacione = () => {
    setTitulaciones((titulacionRecibida) => [
      ...titulacionRecibida,
      {
        titulo: "",
        organismo: "",
      },
    ]);
  };
  const anadirRequisito = () => {
    setRequisitos((requisitoRecibida) => [
      ...requisitoRecibida,
      createRequisito(),
    ]);
  };

  //Elimina un objeto en concreto (index) de un array de objetos (general, setgeral), con un estado de carga(setGeneralMostrar)
  const eliminarGeneral = (index, setGeneralMostrar, general, setGeneral) => {
    setGeneralMostrar(false);
    new Promise((resolve) => {
      const newItems = [...general];
      newItems.splice(index, 1);
      setGeneral(newItems);
      resolve();
    }).then(() => setGeneralMostrar(true));
  };

  useEffect(() => {
    getListadoRequisitosFormacion(params?.idsol).then((data) => setRequisitosSelect(data));
    getListadoTitulacionesAcademicas(params?.idsol).then((data) => setTitulacionesSelect(data));
  }, [params?.idsol]);

  return (
    <>
      <Header></Header>
      <div
        className="container d-flex flex-column min-vh-100 card mt-5"
        id="inicio"
        role="main" data-landmark-index="4"
      >
        <div className="my-auto">
          <div className="container-login">
            <div className="tituloSolicitud">
              {/*<Titulo titulo={"Anexo II.3"} tipo={"tituloPagina"} />*/}
              <h2 className="tituloPagina">Anexo II.3</h2>
              <div className="d-flex align-items-center flex-column">
                {/*<Titulo
                  titulo={"ALEGACIÓN DE REQUISITOS ESPECÍFICOS"}
                  tipo={"tituloPagina subTituloPagina"}
                />*/}
                <h2 className="tituloPagina">ALEGACIÓN DE REQUISITOS ESPECÍFICOS</h2>

              </div>
              <div className="d-flex flex-column m-2">
                <div className="infoAnexoII3">
                  <p>
                    Convocatoria para la provisión de puestos de trabajo
                    vacantes singularizados de personal funcionario de la
                    Administración de la Comunidad Autónoma de Extremadura, (DOE
                    nº 97 de fecha 22/05/2015).
                  </p>
                </div>
                <div className="nSolicitud">
                  <p>
                    Nº de solicitud:{" "}
                    {/* <span className="fw-bold">{params?.idsol}</span> */}
                    <span className="fw-bold">{location.state?.numSol}</span>
                  </p>
                </div>

                <div className="avisoAnexoII3">
                  <p>
                    Recuerde que sólo necesita indicar estos datos si ha
                    solicitado algún puesto que tenga algún requisito
                    específico. En caso que todos los puestos solicitados estén
                    exentos de requisitos, debe dejar este anexo en blanco.
                  </p>
                </div>
                <div className="formulario">
                  <Formik
                    initialValues={{
                      formEspecifica: requisitosSelect,
                      titAcademicas: titulacionesSelect,
                    }}
                    validate={(valores) => {
                      const errores = {
                        // valores.requisitos
                      };

                      return errores;
                    }}
                    onSubmit={(valores) => {
                      insertRequisitosAnexoII3(requisitosSelect).then(() =>{}
                        
                      );
                    }}
                  >
                    {({ errors }) => (
                      <>
                        <Form>
                          <div className="formacionEspecifica">
                            {/*<Titulo
                              clases={"subSubTituloSolicitud p-2 fw-bold"}
                              tipo={"tituloCard noBg"}
                              titulo={"Formación Específica y Otros"}
                            ></Titulo>*/}
                            <div className="d-flex justify-content-between">
                              <h3 className="tituloPagina">Formación Específica y Otros</h3>
                            </div>
                            {requisitosMostar ? (
                              <div className="d-flex flex-column">
                                {requisitos.map((input, i) => (
                                  <div className="row" key={i}>
                                    <div className="col-lg-3">
                                      {i === 0 ? <label htmlFor="dorgexpfor" className="tituloForm">Organismo:</label> : <span></span>}
                                      <input
                                        type="text"
                                        name="dorgexpfor"
                                        className="form-control mt-2"
                                        id={input.id}
                                        defaultValue={input.organismo}
                                        onChange={(event) =>
                                          (input.organismo = event.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="col-lg-3">
                                      {i === 0 ? <label htmlFor="requisito1" className="tituloForm">Requisito:</label> : <span></span>}
                                      <select
                                        name="requisito1"
                                        className="form-select mt-2 "
                                        onChange={(event) =>
                                        (input.requisito1 =
                                          event.target.value)
                                        }
                                        defaultValue={input.requisito1}
                                      >
                                        <option value="" disabled>
                                          Seleccione una opción
                                        </option>
                                        {requisitosSelect.map((requisitos, i) => (
                                          <option
                                            value={requisitos.codExp}
                                            key={i}
                                          >
                                            {requisitos.dexp}
                                          </option>
                                        ))}
                                      </select>
                                    </div>

                                    <div className={`col-lg-2 d-flex  align-items-center`}>
                                      {i === 0 ?
                                        <i
                                          className={`fa-solid fa-remove fs-2 m-3 pt-3  text-third-1 cursorPointer`}
                                          role="button"
                                          aria-label="Eliminar formación específica"
                                          tabIndex={0}
                                          onKeyDown={(e) => { 
                                            if (e.key === "Enter" || e.key === " " ) {
                                              eliminarGeneral(
                                                i,
                                                setRequisitosMostrar,
                                                requisitos,
                                                setRequisitos
                                              );
                                            }                                  
                                          }}  
                                          onClick={() => {
                                            eliminarGeneral(
                                              i,
                                              setRequisitosMostrar,
                                              requisitos,
                                              setRequisitos
                                            );
                                          }}
                                        ></i> :
                                        <i
                                          className="fa-solid fa-remove fs-2  text-third-1 ms-3 mb-3 pt-2 cursorPointer"
                                          role="button"
                                          aria-label="Eliminar formación específica"
                                          tabIndex={0}
                                          onKeyDown={(e) => { 
                                            if (e.key === "Enter" || e.key === " " ) {
                                              eliminarGeneral(
                                                i,
                                                setRequisitosMostrar,
                                                requisitos,
                                                setRequisitos
                                              
                                            );
                                          }}}  
                                          onClick={() => {
                                            eliminarGeneral(
                                              i,
                                              setRequisitosMostrar,
                                              requisitos,
                                              setRequisitos
                                            );
                                          }}
                                        ></i>}
                                    </div>
                                  </div>
                                ))}
                                <i className="fa-solid m-2"
                                  title="Añadir formación específica"
                                  onClick={anadirRequisito}
                                  role="button"
                                  aria-label="Añadir formación específica"
                                  tabIndex={0}
                                  onKeyDown={(e) => { 
                                    if (e.key === "Enter" || e.key === " " ) {
                                      anadirRequisito()
                                    }                                  
                                  }}  
                                >
                                  <span className=" m-3 cursorPointer textAnadir">

                                    {Iconos.iconoMas} Añadir

                                  </span>
                                </i>
                              </div>
                            ) : (
                              <SpinnerCircleMini></SpinnerCircleMini>
                            )}
                          </div>
                          {titulacionesMostar ? (
                            <div className="titulacionesAcademicas">
                              {/*<Titulo
                                clases={"subSubTituloSolicitud p-2 fw-bold"}
                                tipo={"tituloCard noBg"}
                                titulo={"Titulaciones Académicas"}
                              ></Titulo>*/}
                              <div className="d-flex justify-content-between">
                                <h3 className="tituloPagina">Titulaciones Académicas</h3>
                            </div>

                              {titulaciones.map((input, i) => (
                                <div className="d-flex" key={i}>
                                  <div className="w-100 flex-column m-2 me-2">
                                    {i === 0 ? <label htmlFor="organismoTit" className="tituloForm">Organismo:</label> : <span></span>}
                                    <input
                                      type="text"
                                      name="organismoTit"
                                      className="form-control mt-2"
                                      id={input.id}
                                      defaultValue={input.organismo}
                                      onChange={(event) =>
                                        (input.organismo = event.target.value)
                                      }
                                    />
                                  </div>
                                  <div className="w-100 flex-column m-2">
                                    {i === 0 ? <label htmlFor="titAcademicas" className="tituloForm">Titulación:</label> : <span></span>}
                                    <select
                                      name="titAcademicas"
                                      className="form-select mt-2"
                                      onChange={(event) =>
                                        (input.titulo = event.target.value)
                                      }
                                      defaultValue={input.titulo}
                                    >
                                      <option value={""} disabled>
                                        Seleccione una opción
                                      </option>
                                      {titulacionesSelect.map((titulacion, i) => (
                                        <option
                                          value={titulacion.ctitulacion}
                                          key={i}
                                        >
                                          {titulacion.dtitulacion}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  {i === 0 ?
                                    <i
                                      className="fa-solid fa-remove fs-2 mt-3 text-third-1 pt-4 cursorPointer"
                                      role="button"
                                      aria-label="Eliminar formación específica"
                                      tabIndex={0}
                                      onKeyDown={(e) => { 
                                        if (e.key === "Enter" || e.key === " " ) {
                                           eliminarGeneral(
                                             i,
                                             setTitulacionesMostrar,
                                             titulaciones,
                                            setTitulaciones
                                           );
                                        }}}
                                      onClick={() => {
                                        eliminarGeneral(
                                          i,
                                          setTitulacionesMostrar,
                                          titulaciones,
                                          setTitulaciones
                                        );
                                      }}
                                    ></i> :
                                    <i
                                      className="fa-solid fa-remove fs-2  text-third-1 pt-4 cursorPointer"
                                      role="button"
                                      aria-label="Eliminar formación específica"
                                      tabIndex={0}
                                      onKeyDown={(e) => { 
                                        if (e.key === "Enter" || e.key === " " ) {
                                           eliminarGeneral(
                                             i,
                                             setTitulacionesMostrar,
                                             titulaciones,
                                            setTitulaciones
                                           );
                                        }}}
                                      onClick={() => {
                                        eliminarGeneral(
                                          i,
                                          setTitulacionesMostrar,
                                          titulaciones,
                                          setTitulaciones
                                        );
                                      }}
                                    ></i>}
                                </div>
                              ))}
                              <i className="fa-solid m-2"
                                title="Añadir titulaciones"
                                onClick={anadirTitulacione}
                                role="button"
                                  aria-label="Añadir titulaciones"
                                  tabIndex={0}
                                  onKeyDown={(e) => { 
                                    if (e.key === "Enter" || e.key === " " ) {
                                      anadirTitulacione()
                                    }                                  
                                  }}  
                              >
                                <span className=" m-3 cursorPointer textAnadir">

                                  {Iconos.iconoMas} Añadir

                                </span>
                              </i>
                            </div>
                          ) : (
                            <SpinnerCircleMini></SpinnerCircleMini>
                          )}
                          <div className="d-flex my-2 row justify-content-center">
                            <div className="col-md-6">
                               <button
                              id="guardarAnexoii3"
                              className="btnRed rounded m-2 btnCancelarII3"
                              type="button"
                              onClick={() =>
                                setShow({
                                  mensaje: true,
                                  content: "¿Deseas cancelar el formulario?",
                                  tipo: "tituloModal",
                                  aviso: true,
                                  destinoAviso: `/consModSolicitudes/${params.idcon}/${params.idsol}`,
                                })
                              }
                            >
                              <i className="fa-solid fa-rotate-left"></i> Volver
                            </button>
                            </div>
                            <div className="col-md-6">
                              <button
                              id="grabarAnexoii3"
                              className="btn m-2"
                              type="submit"
                              onClick={onsubmit}
                            >
                              <i className="fa-solid fa-save"></i> Guardar
                              
                            </button>
                            </div>
                           

                            
                          </div>
                        </Form>
                      </>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
      {show.mensaje ? (
        <ModalMensajes
          show={show.mensaje}
          handleClose={handleClose}
          texto={show.content}
          tipo={show.tipo}
          aviso={show.aviso}
          destinoAviso={show.destinoAviso}
          destinoCerrar={show?.destinoCerrar}
        ></ModalMensajes>
      ) : null}
    </>
  );
};
export default AnexoII3;
